import { createFileRoute } from '@tanstack/react-router'
import { Inventory } from '../../../../../ui'

export const Route = createFileRoute(
	'/_auth/company/$companyId/settings/inventory',
)({
	component: RouteComponent,
})

function RouteComponent() {
	return <Inventory />
}
